<template>
    <div class="the-hot">
        <div class="title">
            <div class="text">历史搜索</div>
            <img src="@img/clean.png" alt="" srcset="" @click="clean">
        </div>
        <div class="list">
            <div class="item" v-for="(item, index) in list" :key="index + item" @click="onClick(item)">
                <img src="@img/clock.png">
                <span class="text">{{ item.key }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "the-hot",
    mixins: [],
    props: {
      list: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    components: {},
    data() {
      return {

      }
    },
    methods: {
        onClick(item) {
            this.$emit('click', item)
        },
        clean() {
          this.$emit('clearClick')
        }
    },
    mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-hot {
    padding: 20px;

    .title {
        font-size: 20px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        img {
            transform: scale(1);
            transition: .2s ease-in-out;

            &:hover {
            transform: scale(1.2);
                transition: .2s ease-in-out;
            }
        }
    }

    .list {
        margin-top: 15px;
        max-height: 300px;
        overflow-y: auto;

        .item {
            display: flex;
            align-items: center;
            opacity: 1;
            border-radius: 20px;
            background: rgba(189, 211, 255, 0.2);
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 4px 10px;
            cursor: pointer;
            transition: .2s ease-in-out;

            img {
                margin-right: 14px;
            }

            .text {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                color: rgba(78, 85, 135, 1);
            }

            &+.item {
                margin-top: 14px;
            }

            &:hover {
                transition: .2s ease-in-out;
                background: rgba(189, 211, 255, 0.8);
            }
        }
    }
}
</style>
